import { render, staticRenderFns } from "./BmClientesDetalles.vue?vue&type=template&id=25e06300&"
import script from "./BmClientesDetalles.vue?vue&type=script&lang=js&"
export * from "./BmClientesDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports